(function () {
    'use strict';

    angular
        .module('authenticator', [])
        .factory('authenticator', authenticator);

    authenticator.$inject = ['$http', '$cookies', '$q', 'dateParser', '$rootScope', 'cache'];

    function authenticator($http, $cookies, $q, dateParser, $rootScope, cache) {
        var factory = this;
        factory.user = {};

        factory.login = login;
        factory.loginLight = loginLight;
        factory.isLight = isLight;
        factory.logout = logout;
        factory.authenticate = authenticate;
        factory.checkLoginStatus = checkLoginStatus;
        factory.loginWithFacebook = loginWithFacebook;
        factory.logoutFacebook = logoutFacebook;
        factory.checkFacebookLoginStatus = checkFacebookLoginStatus;
        factory.isLoggedInWithFacebook = isLoggedInWithFacebook;
        factory.promptFacebookLogin = promptFacebookLogin;
        factory.remember_me = null;

        init();
        function init(){
            factory.cookie_options = {
                path: '/'
            };
        }

        function login(email, password, remember_me) {
            if (remember_me !== null) {
                factory.remember_me = remember_me;
            }

            var hashed_password = md5(password);

            // Login with the input password
            return authenticate(email, hashed_password)
                .then(function (response) {
                    return response;
                });
        }

        function loginLight(email) {
            // Login with the input password
            return authenticateLight(email)
                .then(function (response) {
                    return response;
                });
        }

        function logout() {
            var deferred = $q.defer();

            cache.clear();

            // Remove cookies
            $cookies.remove('_user_email_');
            $cookies.remove('_user_password_');
            $cookies.remove('_is_verified_');
            $cookies.remove('_user_light_');
            $cookies.remove('user_id');

            $http.post('api/logout', {}).then(function(response){});

            // make sure that the user is logged out of facebook in app as well
            if(isLoggedInWithFacebook()){
                logoutFacebook().then(function(response){
                    deferred.resolve(response);
                });
            } else {
                deferred.resolve(true);
            }

            return deferred.promise;
        }

        // promise based authentication
        function authenticate(email, hashed_password) {
            return $http.post('api/authenticate/', {
                'user_email': email,
                'user_password': hashed_password,
                'user_remember_login': factory.remember_me,
                'user_logged_in_with_facebook': factory.isLoggedInWithFacebook()
            })
                .then(function (response) {
                    factory.remember_me = response.data.user_remember_login;

                    var now = new Date();
                    if (response.data.user_remember_login) {
                        var expiration = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
                        factory.cookie_options.expires = expiration;
                    }

                    if(response.data.facebook_login_validated){
                        setCookiesFacebookLogin(response.data);
                        return true;
                    } else if (response.data.email != undefined) {
                        // if the validation was based on regular logout
                        $cookies.remove('_user_light_');
                        $cookies.put('_user_email_', response.data.email, factory.cookie_options);
                        $cookies.put('_user_password_', response.data.password, factory.cookie_options);
                        $cookies.put('_is_verified_', response.data.is_verified, factory.cookie_options);
                        $cookies.put('user_id', response.data.user_id, factory.cookie_options);
                        factory.user = response.data;

                        return true;
                    } else {
                        // Remove the cookies (if they were set wrongly)
                        $cookies.remove('_user_email_');
                        $cookies.remove('_user_password_');
                        $cookies.remove('_is_verified_');
                        $cookies.remove('_user_light_');
                        $cookies.remove('user_id');
                        // force logout of facebook
                        logoutFacebook(angular.noop());

                        if (response.data.no_email_found) {
                            return 'no_email_found';
                        } else {
                            return false;
                        }
                    }
                });
        }

        function authenticateLight(email) {
            return $http.post('api/authenticate/light/', {
                'user_email': email
            }).then(function (response) {
                var now = new Date();
                if (response.data.email != undefined) {
                    // if the validation was based on regular logout
                    $cookies.put('_user_email_', response.data.email, factory.cookie_options);
                    $cookies.put('_user_light_', 1, factory.cookie_options);
                    $cookies.put('user_id', response.data.user_id, factory.cookie_options);
                    factory.user = response.data;

                    return true;
                } else {
                    // Remove the cookies (if they were set wrongly)
                    $cookies.remove('_user_email_');
                    $cookies.remove('_user_light_');
                    $cookies.remove('user_id');

                    if (response.data.no_email_found) {
                        return 'no_email_found';
                    } else {
                        return false;
                    }
                }
            });
        }

        function isLoggedInWithFacebook(){
            if(factory.user_logged_in_with_facebook !== undefined) return factory.user_logged_in_with_facebook;
            if($cookies.get('user_logged_in_with_facebook')) return $cookies.get('user_logged_in_with_facebook') == 'true';
            return false;
        }

        function isLight() {
            return $cookies.get('_user_light_') == 1;
        }

        // Promisebased checkloginstatus
        function checkLoginStatus() {
            // Check if the user login settings are set in the cookies
            if(isLoggedInWithFacebook()){
                return authenticate('','');
            } else if (checkCookies()) {
                if(isLight()) {
                    var deferred = $q.defer();
                    deferred.resolve(true);
                    return deferred.promise;
                }
                return authenticate($cookies.get('_user_email_'), $cookies.get('_user_password_'));
            } else {
                // if there is no cookie remove information from localstorage to block further api calls
                var deferred = $q.defer();
                deferred.resolve(false);
                return deferred.promise;
            }
        }

        function checkCookies() {
            var user = {};
            user.email = $cookies.get('_user_email_');

            if (user.email != undefined) {
                return true;
            } else {
                return false;
            }
        }

        function checkFacebookLoginStatus(){
            var deferred = $q.defer();
            $rootScope.fb_initialized.promise.then(function(response){
                $rootScope.FB.getLoginStatus(function(response) {
                    if (response.status === 'connected') {
                        factory.user_logged_in_with_facebook = true;
                        // Logged into your app and Facebook.
                        deferred.resolve(response)
                    } else {
                        // The person is not logged into your app or we are unable to tell.

                        logoutFacebook()
                            .then(function(response){
                                console.error("Not logged into facebook");
                                deferred.resolve(false)
                            });

                    }
                });
            });
            return deferred.promise;
        }

        function promptFacebookLogin() {
            var deferred = $q.defer();
            $rootScope.fb_initialized.promise.then(function (response) {
                $rootScope.FB.login(function (response) {
                    if (response.status === 'connected') {
                        factory.user_logged_in_with_facebook = true;
                        deferred.resolve(response);
                    } else {
                        // The person is not logged into your app or we are unable to tell.
                        deferred.resolve(false)
                    }

                }, {scope: 'public_profile,email'});
            });
            return deferred.promise;
        }

        function loginWithFacebook(){
            return promptFacebookLogin().then(function(response){
                if(response){
                    factory.user_logged_in_with_facebook = true;
                    // Logged into your app and Facebook.
                    return $http.post('api/login/facebook', response.authResponse)
                        .then(function(response){
                            setCookiesFacebookLogin(response.data);
                            return response;
                        });
                }
            });

        }

        function logoutFacebook(){
            var deferred = $q.defer();
            $rootScope.fb_initialized.promise.then(function(response){

                $http.post('api/logout/facebook/', {})
                    .then(function(response){
                        factory.user_logged_in_with_facebook = false;
                        deferred.resolve(response);
                        $rootScope.FB.logout(function(response){

                        });
                    });

                $cookies.remove('user_logged_in_with_facebook');
            });

            return deferred.promise;
        }

        function setCookiesFacebookLogin(data){
            factory.cookie_options.expires = dateParser.parseDate(data.facebook_token_expires_at);
            // if the backend has successfully validated a facebook login
            $cookies.put('user_logged_in_with_facebook', 'true', factory.cookie_options);
        }

        return factory;
    }
})();
